/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RefreshTokenResponse } from './RefreshTokenResponse';
import {
    RefreshTokenResponseFromJSON,
    RefreshTokenResponseFromJSONTyped,
    RefreshTokenResponseToJSON,
    RefreshTokenResponseToJSONTyped,
} from './RefreshTokenResponse';

/**
 * 
 * @export
 * @interface ResultOfRefreshTokenResponse
 */
export interface ResultOfRefreshTokenResponse {
    /**
     * 
     * @type {RefreshTokenResponse}
     * @memberof ResultOfRefreshTokenResponse
     */
    data: RefreshTokenResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfRefreshTokenResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfRefreshTokenResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfRefreshTokenResponse interface.
 */
export function instanceOfResultOfRefreshTokenResponse(value: object): value is ResultOfRefreshTokenResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfRefreshTokenResponseFromJSON(json: any): ResultOfRefreshTokenResponse {
    return ResultOfRefreshTokenResponseFromJSONTyped(json, false);
}

export function ResultOfRefreshTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfRefreshTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': RefreshTokenResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfRefreshTokenResponseToJSON(json: any): ResultOfRefreshTokenResponse {
    return ResultOfRefreshTokenResponseToJSONTyped(json, false);
}

export function ResultOfRefreshTokenResponseToJSONTyped(value?: ResultOfRefreshTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': RefreshTokenResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

